<template>
    <div class="wrapper" style="width:640px" >
        <!-- :style="getPcWebStyle()" -->
        <!-- loading -->
        <div class="loading" v-show="loadingShow">
            <img src="//shouji.sogou.com/sapp/worldcup2014/images/loading-sg.gif" alt="">
        </div>
        <!-- content内容区域 -->
        <div class="body-wrap" ref="shareContent">
            <!-- 这是背景 图片 预先加载区域 -->
            <div style="width:0px; height:0px; overflow:hidden">
                <img src="../assets/share/tanbackf.png" alt="">
                <img src="../assets/share/bottomback.png" alt="">
                <img src="../assets/share/anzhuodiback.png" alt="">
                <img src="../assets/share/iosdiback.png" alt="">
                <img src="../assets/share/back.png" alt="">
            </div>
            <!-- 图片元素 气泡-->
            <div class="share-ele">
                <img class="bubble3" src="../assets/share/bubble3.png" alt="">
                <img class="bubble7" src="../assets/share/bubble7.png" alt="">
                <img class="bubble4" src="../assets/share/bubble4.png" alt="">
                <img class="bubble6" src="../assets/share/bubble6.png" alt="">
                <img class="bubble11" src="../assets/share/bubble11.png" alt="">
                <img class="bubble9" src="../assets/share/bubble9.png" alt="">
                <img class="bubble10" src="../assets/share/bubble10.png" alt="">
                <img class="bubble8" src="../assets/share/bubble8.png" alt="">
            </div>
            <!-- 头部 -->
            <div class="share-top">
                <img class="logo" src="../assets/share/logo.png" alt="">
                <img class="logo-text" src="../assets/share/logotext.png" alt="">
            </div>
            <!-- 对话框部分 -->
            <div class="share-main" >
                <div class="main-text">
                    <img src="../assets/share/title.png" alt="">
                </div>
                <div class="main-dialog" :class="[is.isiOS? 'ios-dialog':'android-dialog']">
                    <img class="chat" src="../assets/share/liaotian.png" alt="">
                    <img class="tutorial ios-tutorial" v-if='is.isiOS' src="../assets/share/iosjiaocheng.png" alt="">
                    <img class="tutorial android-tutorial" v-if="!is.isiOS" src="../assets/share/anzhuojiaocheng.png" alt="">
                </div>
            </div>
            <!-- 底部 -->
            <div class="share-bottom" style="width:640px">
                <div class="bottom-content">
                    <div class="download" @click="download" v-if="!is.isSplashScreen" ref="btn1" :data-clipboard-text="codeStr">
                        <img src="../assets/share/downloadbtn.png" alt="">
                    </div>
                    <!-- ref="btn2" :data-clipboard-text="codeStr" -->
                    <div class="tiyan" @click="openMessage" >
                        <!-- <img src="../assets/share/waitbtn.png" alt=""> -->
                        <img  src="../assets/share/tiyanbtn.png" alt="">
                    </div>
                </div>
            </div>
            <!-- 弹窗 -->
            <div class="share-shadow" v-show="is.isShowMessage" >
                <div class="share-message-box">
                    <div class="share-messge-box__header">
                        <div>
                            <img class="share-message-header" src="../assets/share/popuptop.png" alt="">
                        </div>
                        <div @click="closeMessage" class="share-messge-close">
                            <img  src="../assets/share/closebtn.png" alt=""  >
                        </div>
                    </div>
                    <div class="share-message-box__body">
                        <div class="share-message-content1">
                            <img class="share-message-text" src="../assets/share/popup1text.png" alt="">
                        </div>
                        <div class="share-message-content2">
                            <img class="share-message-text" src="../assets/share/popup2text.png" alt="">
                            <img v-if="!is.isiOS" class="tan2tu1" src="../assets/share/popup2tu1anzhuo.png" alt="">
                            <img v-if="is.isiOS" class="tan2tu1" src="../assets/share/popup2tu1ios.png" alt="">
                            <img v-if="!is.isiOS" class="tan2tu2 android-tan2tu2" src="../assets/share/popup2tu2anzhuo.png" alt="">
                            <img v-if="is.isiOS" class="tan2tu2 ios-tan2tu2" src="../assets/share/popup2tu2ios.png" alt="">
                        </div>
                        <div class="share-message-content3">
                            <img class="share-message-text"  src="../assets/share/popup3text.png" alt="">
                            <img v-if="!is.isiOS" class="tan3tu1" src="../assets/share/popup3tu1anzhuo.png" alt="">
                            <img v-if="is.isiOS" class="tan3tu1" src="../assets/share/popup3tu1ios.png" alt="">
                        </div>
                        <div class="share-message-content4" v-if="!is.isSplashScreen">
                            <div>
                                <img class="share-message-text" src="../assets/share/popup4text.png" alt="">
                            </div>
                            <div @click="download" ref="btn3" :data-clipboard-text="codeStr">
                                <img class="share-message-download" src="../assets/share/downloadbtnsmall.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Clipboard from 'clipboard'
import {weixinInit} from '@/util/weixinExtend.js'
import {parseUrlSearch, sogouDownload } from '@/util/util.js'
export default {
    name:'Share',
    data(){
        return {
            downloadUrl:'',
            count:0,
            loadingShow:true,
            urlQuery:{},
            codeStr:'',
            is:{
                isSplashScreen:false,
                isShowMessage:false,
                isiOS:false,
            }
        }
    },
    watch:{
        // 图片数目变化 需要修改的地方 todo
        count(val){
            if(val >= 25 && this.loadingShow){
                this.loadingShow = false
            }
        }
    },
    created(){
        this.urlQuery = parseUrlSearch(window.location.href)
        // 判断是否是 ios , 用于区分 安卓和ios 资源， pc端资源用安卓 的
        this.is.isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        this.copyStr()
    },
    mounted(){
        this.initClipboard()
        this.isInInputApp()
        this.getDownloadUrl()
        // 简单图片加载
        this.preload()
        weixinInit()
    },
    methods:{
        initClipboard(){
            const clipboard1 = new Clipboard(this.$refs.btn1);
            clipboard1.on('success', (e) => {
                let str = 'chatbubblesharepage_clipboard_text_' + ''+e.text
                pb_count(encodeURIComponent(str))
                e.clearSelection();
            });
            clipboard1.on('error', (e) => {
                // console.log('1.复制失败，请再次尝试') 
            });
            const clipboard3 = new Clipboard(this.$refs.btn3);
            clipboard3.on('success', (e) => {
                // console.log('3.复制成功，请前往使用')
                let str = 'chatbubblesharepage_clipboard_text_' +  '' + e.text
                pb_count(encodeURIComponent(str))
                e.clearSelection();
            });
            clipboard3.on('error', (e) => {
                // console.log('3.复制失败，请再次尝试')
            });
        },
        isInInputApp(){
            try {
                if(Object.keys(this.urlQuery).length && this.urlQuery.hasOwnProperty('splashscreen')&& this.urlQuery.splashscreen){
                    // console.log('hgello,存在在 输入法 是闪屏的 内容',typeof this.urlQuery.splashscreen)
                    this.is.isSplashScreen = true
                }else{
                    // console.log('无内容')
                }
            } catch (error) {
                console.log('error')
            }
        },
        // 立即体验 open
        openMessage(){
            this.is.isShowMessage = true
        },
        // 弹窗 关闭close
        closeMessage(){
            this.is.isShowMessage = false
        },
        // 下载按钮 
        download(){
            // 解决 pc上的 复制失败问题
            let timer = setTimeout(()=>{
                sogouDownload(this.downloadUrl)
                clearTimeout(timer)
            },10)
        },
        // 预加载 图片(区域是 非loading 以外的)
        preload(){
            let imgs = this.$refs.shareContent.querySelectorAll('img')
            Array.from(imgs).forEach((item)=>{
                let img = new Image()
                img.onload = ()=>{
                    this.count++
                }
                img.src=item.getAttribute('src')
            })
        },

        // 判断并获取 安卓 还是ios 安装包
        getDownloadUrl(){
            if(this.is.isiOS){
                this.downloadUrl = 'https://apps.apple.com/app/apple-store/id917670924?pt=625281&ct=chatbubbles&mt=8'
            }else{
                this.downloadUrl = 'http://shouji.sogou.com/apkdl/?gr=share&tp=chatstyle'
            }
        },

        copyStr(){
            let act = this.urlQuery.act || 'origin'
            let bl = this.urlQuery.bl || 'gxh'
            let f = this.urlQuery.f || 'origin'
            let id = 0

            let str = `sginputshare://clipboard_chatbubble_share_act_${act}_bl_${bl}_from_${f}_id_${id}`
            let length = str.length
            let base64Str =str + '{'+length+ '}' 
            // console.log(base64Str, window.btoa(base64Str))
            let code  = encodeURI('#!#sgsrfpbcd$!$' + window.btoa(base64Str))
            this.codeStr = code
            return code
        }
    }
}
</script>
